import * as THREE from "three"

import particlesVertexShader from "../../shaders/environmentParticles/vertex.glsl"
import particlesFragmentShader from "../../shaders/environmentParticles/fragment.glsl"
import { environmentParticlesFolder, scene } from "./Experience"
import { Vector3 } from "three";

export class EnvironmentParticles {
  constructor() {
    this.setParticles()
    this.setTweaks()
  }

  setParticles() {
    // const fireFliesCount = 800
    const fireFliesCount = 1000

    const fireFliesGeometry = new THREE.BufferGeometry()

    const positions = []
    const positionVectors = []
    const randoms = new Float32Array(fireFliesCount)

    const n = 5,
      n2 = n / 2 // particles spread in the sphere + put sphere in center

    for (let i = 0; i < fireFliesCount; i++) {
      // positions
      const x = Math.random() * n - n2
      const y = Math.random() * n - n2
      const z = Math.random() * n - n2

      positionVectors.push(new THREE.Vector3(x, y, z))

      if (positionVectors[i].distanceTo(new THREE.Vector3(0, 0, 0)) < n / 2) {
        positions.push(x, y, z)
        randoms[i] = Math.random()
      }
    }

    fireFliesGeometry.setAttribute(
      "position",
      new THREE.Float32BufferAttribute(positions, 3)
    )
    fireFliesGeometry.setAttribute(
      "aRandom",
      new THREE.BufferAttribute(randoms, 1)
    )

    fireFliesGeometry.computeBoundingSphere()

    this.fireFliesMaterialMouse = new THREE.ShaderMaterial({
      vertexShader: particlesVertexShader,
      fragmentShader: particlesFragmentShader,
      transparent: true,
      blending: THREE.AdditiveBlending,
      depthWrite: false,

      stencilWrite: true,
      stencilFunc: THREE.EqualStencilFunc,
      stencilRef: 1,

      uniforms: {
        uTime: { value: 0 },
        uPixelRatio: { value: Math.min(window.devicePixelRatio, 2) },
        uSize: { value: 0.7 },
        uFallSpeed: { value: 0.009 },
        uSwirlSpeed: { value: 0.025 },
        uAlpha: { value: 1 },
      },
    })

    this.fireFliesMaterial = new THREE.ShaderMaterial({
      vertexShader: particlesVertexShader,
      fragmentShader: particlesFragmentShader,
      transparent: true,
      blending: THREE.AdditiveBlending,
      depthWrite: false,
      uniforms: {
        uTime: { value: 0 },
        uPixelRatio: { value: Math.min(window.devicePixelRatio, 2) },
        // uSize: { value: 0.3 },
        // uFallSpeed: { value: 0.009 },
        // uSwirlSpeed: { value: 0.025 },
        // uAlpha: { value: 1 },
        uSize: { value: 1.3 },
        uFallSpeed: { value: -0.037 },
        uSwirlSpeed: { value: 0.057 },
        uAlpha: { value: 0.261 },
      },
    })

    this.fireFliesPointsMouse = new THREE.Points(
      fireFliesGeometry,
      this.fireFliesMaterialMouse
    )
    this.fireFliesPointsMouse.position.set(0, 1, -0.5)
    this.fireFliesPointsMouse.rotateOnAxis(new Vector3(0, 0, 1), 90);
    scene.add(this.fireFliesPointsMouse)

    this.fireFliesPoints = new THREE.Points(
      fireFliesGeometry,
      this.fireFliesMaterial
    )
    this.fireFliesPoints.position.set(0, 1, -0.5)
    scene.add(this.fireFliesPoints)
  }

  setTweaks() {
    environmentParticlesFolder.addInput(
      this.fireFliesMaterial.uniforms.uSize,
      "value",
      {
        min: 0,
        max: 4,
        step: 0.01,
        label: "Size",
      }
    )

    environmentParticlesFolder.addInput(
      this.fireFliesMaterial.uniforms.uFallSpeed,
      "value",
      {
        min: -0.1,
        max: 0.1,
        step: 0.001,
        label: "Fall Speed",
      }
    )

    environmentParticlesFolder.addInput(
      this.fireFliesMaterial.uniforms.uSwirlSpeed,
      "value",
      {
        min: 0,
        max: 0.1,
        step: 0.001,
        label: "Swirl Speed",
      }
    )

    environmentParticlesFolder.addInput(
      this.fireFliesMaterial.uniforms.uAlpha,
      "value",
      {
        min: 0,
        max: 1,
        step: 0.001,
        label: "Alpha",
      }
    )
  }

  update(elapsedTime) {
    this.fireFliesMaterial.uniforms.uTime.value = elapsedTime
    this.fireFliesMaterialMouse.uniforms.uTime.value = elapsedTime
  }
}
